import React, { useEffect, useState, useRef } from "react";
import { Card } from "primereact/card";
import { Button } from "primereact/button";
import { InputText } from "primereact/inputtext";
import { DataTable } from "primereact/datatable";
import { Column } from "primereact/column";
import { Dialog } from "primereact/dialog";
import { Calendar } from "primereact/calendar";
import { Checkbox } from "primereact/checkbox";
import { Toast } from 'primereact/toast';
import { RetraitService } from "../service/RetraitService";

import { addLocale, locale } from 'primereact/api';
import { Notify } from "../Notify";

addLocale('fr', {
  firstDayOfWeek: 1,
  dayNames: ['dimanche', 'lundi', 'mardi', 'mercredi', 'jeudi', 'vendredi', 'samedi'],
  dayNamesShort: ['dim', 'lun', 'mar', 'mer', 'jeu', 'ven', 'sam'],
  dayNamesMin: ['D', 'L', 'M', 'M', 'J', 'V', 'S'],
  monthNames: [
    'janvier', 'février', 'mars', 'avril', 'mai', 'juin',
    'juillet', 'août', 'septembre', 'octobre', 'novembre', 'décembre'
  ],
  monthNamesShort: ['janv.', 'févr.', 'mars', 'avr.', 'mai', 'juin', 'juil.', 'août', 'sept.', 'oct.', 'nov.', 'déc.'],
  today: 'Aujourd\'hui',
  clear: 'Effacer'
});

locale('fr');

function RetraitDiplome() {
  const [formData, setFormData] = useState({
    idRetraitDiplome: null,
    idInscription: null,
    //anneeAcadmique: null,
    ine: "",
    dateRetrait: null,
    nom: "",
    prenom: "",
    numCnib: "",
    fgProcuration: false,
  });

  const [inscriptions, setInscriptions] = useState([]);
  const [inscription, setInscription] = useState(null);
  const [retraitDialog, setRetraitDialog] = useState(false);
  const [spin, setSpin] = useState(false);
  const retraitService = new RetraitService();

  const toast = useRef()
  const dt = useRef(null)
  const notify = new Notify()

  const searcheInscription = async () => {
    if(formData.ine.trim() !==''){
      await retraitService.getInscriptionsEtudiant(formData.ine).then(data => {
      if(data.length ===0) notify.showError(toast, "Cet INE n'existe pas !")
      setInscriptions(data)
      console.log(data)
    })
    .catch(error => {
      console.log(error)
    })
    }
    else notify.showError(toast, "Veuillez saisir un INE !")

  };

  const retiterDiplome = (inscriptionEtudiant) => {
    setSpin(false);
    retraitService.getRetrait(inscriptionEtudiant.idInscription).then(data => {
      console.log(data)
      const isRetrait = data?.idInscription
      if(isRetrait) notify.showError(toast, "Ce diplôme a été déjà retiré !")
      else {
        setInscription(inscriptionEtudiant);
        setFormData({
          ...formData,
          idInscription: inscriptionEtudiant.idInscription,
          nom: inscriptionEtudiant.adEtudiant.nomEtudiant,
          prenom: inscriptionEtudiant.adEtudiant.prenomEtudiant,
          fgProcuration: false,
          numCnib: "",
          dateRetrait: null,
        });
        setRetraitDialog(true);
      }
    })
    .catch(error => {
      console.log(error)
    })
    
  };

  const hideDialog = () => setRetraitDialog(false);

  const handleProcurationChange = (e) => {
    const checked = e.checked;
    setFormData((prev) => ({
      ...prev,
      fgProcuration: checked,
      nom: checked ? "" : inscription?.nom || "",
      prenom: checked ? "" : inscription?.prenom || "",
    }));
  };

  const saveRetrait = async () => {
    setSpin(true);
    try {
      const retraitDip = {
        idRetraitDiplome : formData.idRetraitDiplome,
        idInscription: formData.idInscription,
        dateRetrait: formData.dateRetrait,
        nom: formData.nom,
        prenom: formData.prenom,
        numCnib: formData.numCnib,
        estRetire: true,
        fgProcuration: formData.fgProcuration
      }
      await retraitService.faireRetait(retraitDip).then(data => {
        retraitService.getInscriptionsEtudiant(formData.ine).then(dataIns => {
          setInscriptions(dataIns)
        })
        notify.showSuccess(toast, "Retrait effectué")
        setRetraitDialog(false);
      })
      .catch(error => {
        console.log(error)
         notify.showError(toast)
      })
      
    } catch (err) {
      console.error("Erreur lors du retrait :", err);
    } finally {
      setSpin(false);
    }
  };

  const actionBodyTemplate = (rowData) => (
    <Button
      type="button"
      icon="pi pi-inbox"
      className="p-button-success"
      title="Retirer diplôme"
      onClick={() => retiterDiplome(rowData)}
    />
  );

  const retraitDialogFooter = (
    <>
      <Button label="Quitter" icon="pi pi-times" className="p-button-text" onClick={hideDialog} />
      <Button
        label="Valider retrait"
        icon={spin ? "pi pi-spin pi-spinner" : "pi pi-check"}
        className="p-button-text"
        onClick={saveRetrait}
      />
    </>
  );

  return (
    <div className="flex justify-content-center mt-5">
      <Toast ref={toast} /> 
      <Card style={{ width: "1050px", textAlign: "center" }}>
        <div className="grid p-fluid text-left">
          <div className="col-6 mb-3">
            <span className="p-float-label">
              <InputText
                id="ine"
                value={formData.ine}
                onChange={(e) => setFormData({ ...formData, ine: e.target.value })}
                className="w-full"
              />
              <label htmlFor="ine">INE</label>
            </span>
          </div>
          <Button
            style={{ marginLeft: 20 }}
            icon="pi pi-search"
            className="p-button-sm p-button-outlined mb-4"
            onClick={searcheInscription}
          />
          <div className="col-12 mb-3">
            <DataTable value={inscriptions} responsive header="Liste des inscriptions" rows={10} paginator emptyMessage="Pas de données à afficher !">
              <Column field="adEtudiant.ine" header="INE" />
              <Column field="adEtudiant.nomEtudiant" header="Nom" />
              <Column field="adEtudiant.prenomEtudiant" header="Prénom" />
              <Column field="adNiveau.libelleNiveau" header="Niveau" />
              <Column field="adAnneeAcadmique.libelleAnnee" header="Année académique" />
              {/*<Column field="retrait" header="Retrait" />
              <Column field="dateRetrait" header="Date rétrait" />*/}
              <Column header="Actions" body={actionBodyTemplate} style={{ textAlign: "center", width: "8em" }} />
            </DataTable>
          </div>
        </div>
      </Card>

      <Dialog
        visible={retraitDialog}
        style={{ width: "90%", maxWidth: "600px" }}
        header="Rétrait de diplôme"
        modal
        className="p-fluid"
        footer={retraitDialogFooter}
        onHide={hideDialog}
      >
        <div className="grid p-fluid text-left">
          
          <div className="col-6 mb-3">
            <span className="p-float-label">
              <Calendar
                id="dateRetrait"
                value={formData.dateRetrait}
                onChange={(e) => setFormData({ ...formData, dateRetrait: e.value })}
                className="w-full"
                dateFormat="dd/mm/yy"
                showIcon
                locale="fr"
              />
              <label htmlFor="dateRetrait">Date de retrait</label>
            </span>
          </div>

          <div className="col-6 mb-3 flex align-items-center gap-2">
            <Checkbox
              inputId="procuration"
              checked={formData.fgProcuration}
              onChange={handleProcurationChange}
            />
            <label htmlFor="procuration">Procuration</label>
          </div>

          <div className="col-6 mb-3">
            <span className="p-float-label">
              <InputText
                id="nom"
                value={formData.nom}
                disabled={!formData.fgProcuration}
                onChange={(e) => setFormData({ ...formData, nom: e.target.value })}
                className="w-full"
              />
              <label htmlFor="nom">Nom de celui qui retire</label>
            </span>
          </div>

          <div className="col-6 mb-3">
            <span className="p-float-label">
              <InputText
                id="prenom"
                value={formData.prenom}
                disabled={!formData.fgProcuration}
                onChange={(e) => setFormData({ ...formData, prenom: e.target.value })}
                className="w-full"
              />
              <label htmlFor="prenom">Prénom de celui qui retire</label>
            </span>
          </div>

          <div className="col-12 mb-3">
            <span className="p-float-label">
              <InputText
                id="numCnib"
                value={formData.numCnib}
                onChange={(e) => setFormData({ ...formData, numCnib: e.target.value })}
                className="w-full"
              />
              <label htmlFor="numCnib">CNIB ou Passeport</label>
            </span>
          </div>
        </div>
      </Dialog>
    </div>
  );
}

export default RetraitDiplome;
